import { combineReducers } from '@reduxjs/toolkit';

import workBackendSlice from './workBackendSlice';
import userDbSlice from './userDbSlice';
import folderDbSlice from './folderDbSlice';
import bookDbSlice from './bookDbSlice';
import sheetDbSlice from './sheetDbSlice';
import sheetInformationDbSlice from './sheetInformationDbSlice';
import paletteDbSlice from './paletteDbSlice';
import cardTemplateDbSlice from './cardTemplateDbSlice';
import cardTemplateAttributeDbSlice from './cardTemplateAttributeDbSlice';
import cardTemplateShapeDbSlice from './cardTemplateShapeDbSlice';
import cardDbSlice from './cardDbSlice';
import cardAttributeDbSlice from './cardAttributeDbSlice';
import cardShapeDbSlice from './cardShapeDbSlice';
import memoCardContentDbSlice from './memoCardContentDbSlice';
import uiCardItemDbSlice from './uiCardItemDbSlice';
import drawCardContentDbSlice from './drawCardContentDbSlice';
import uiCardSampleDataDbSlice from './uiCardSampleDataDbSlice';
import cardCodeTemplateDbSlice from './cardCodeTemplateDbSlice';
import cardCodeDbSlice from './cardCodeDbSlice';
import arrowDbSlice from './arrowDbSlice';
import albumDbSlice from './albumDbSlice';
import imageDbSlice from './imageDbSlice';
import languageDbSlice from './languageDbSlice';
import sheetTreeDbSlice from './sheetTreeDbSlice';
import relationUserFolderDbSlice from './relationUserFolderDbSlice';
import relationUserBookDbSlice from './relationUserBookDbSlice';
import relationUserPaletteDbSlice from './relationUserPaletteDbSlice';
import relationUserCardTemplateDbSlice from './relationUserCardTemplateDbSlice';
import relationFolderBookDbSlice from './relationFolderBookDbSlice';
import relationPaletteCardTemplateDbSlice from './relationPaletteCardTemplateDbSlice';
import relationUserAlbumDbSlice from './relationUserAlbumDbSlice';
import relationUserImageDbSlice from './relationUserImageDbSlice';
import relationAlbumImageDbSlice from './relationAlbumImageDbSlice';
import latelyCardTemplateDbSlice from './latelyCardTemplateDbSlice';
import latelyImageDbSlice from './latelyImageDbSlice';
import jointBookDbSlice from './jointBookDbSlice';
import palettePermissionDbSlice from './palettePermissionDbSlice';
import cardTemplatePermissionDbSlice from './cardTemplatePermissionDbSlice';
import jointPaletteDbSlice from './jointPaletteDbSlice';
import statusJointPaletteDbSlice from './statusJointPaletteDbSlice';
import standbyPaletteJoinedDbSlice from './standbyPaletteJoinedDbSlice';
import standbyCardTemplateJoinedDbSlice from './standbyCardTemplateJoinedDbSlice';
import standbyRelationPaletteCardTemplateJoinedDbSlice from './standbyRelationPaletteCardTemplateJoinedDbSlice';
import standbyPalettePermissionJoinedDbSlice from './standbyPalettePermissionJoinedDbSlice';
import standbyCardTemplatePermissionJoinedDbSlice from './standbyCardTemplatePermissionJoinedDbSlice';
import userConditionSlice from './userConditionSlice';
import noteDbSlice from './noteDbSlice';
import shopSlice from './shopSlice';

const rootReducer = combineReducers({
  workBackend: workBackendSlice,
  userDb: userDbSlice,
  folderDb: folderDbSlice,
  bookDb: bookDbSlice,
  sheetDb: sheetDbSlice,
  sheetInformationDb: sheetInformationDbSlice,
  paletteDb: paletteDbSlice,
  cardTemplateDb: cardTemplateDbSlice,
  cardTemplateAttributeDb: cardTemplateAttributeDbSlice,
  cardTemplateShapeDb: cardTemplateShapeDbSlice,
  cardDb: cardDbSlice,
  cardAttributeDb: cardAttributeDbSlice,
  cardShapeDb: cardShapeDbSlice,
  memoCardContentDb: memoCardContentDbSlice,
  uiCardItemDb: uiCardItemDbSlice,
  drawCardContentDb: drawCardContentDbSlice,
  uiCardSampleDataDb: uiCardSampleDataDbSlice,
  cardCodeTemplateDb: cardCodeTemplateDbSlice,
  cardCodeDb: cardCodeDbSlice,
  arrowDb: arrowDbSlice,
  albumDb: albumDbSlice,
  imageDb: imageDbSlice,
  languageDb: languageDbSlice,
  sheetTreeDb: sheetTreeDbSlice,
  relationUserFolderDb: relationUserFolderDbSlice,
  relationUserBookDb: relationUserBookDbSlice,
  relationUserPaletteDb: relationUserPaletteDbSlice,
  relationUserCardTemplateDb: relationUserCardTemplateDbSlice,
  relationFolderBookDb: relationFolderBookDbSlice,
  relationPaletteCardTemplateDb: relationPaletteCardTemplateDbSlice,
  relationUserAlbumDb: relationUserAlbumDbSlice,
  relationUserImageDb: relationUserImageDbSlice,
  relationAlbumImageDb: relationAlbumImageDbSlice,
  latelyCardTemplateDb: latelyCardTemplateDbSlice,
  latelyImageDb: latelyImageDbSlice,
  jointBookDb: jointBookDbSlice,
  palettePermissionDb: palettePermissionDbSlice,
  cardTemplatePermissionDb: cardTemplatePermissionDbSlice,
  jointPaletteDb: jointPaletteDbSlice,
  statusJointPaletteDb: statusJointPaletteDbSlice,
  standbyPaletteJoinedDb: standbyPaletteJoinedDbSlice,
  standbyCardTemplateJoinedDb: standbyCardTemplateJoinedDbSlice,
  standbyRelationPaletteCardTemplateJoinedDb: standbyRelationPaletteCardTemplateJoinedDbSlice,
  standbyPalettePermissionJoinedDb: standbyPalettePermissionJoinedDbSlice,
  standbyCardTemplatePermissionJoinedDb: standbyCardTemplatePermissionJoinedDbSlice,
  userCondition: userConditionSlice,
  noteDb: noteDbSlice,
  shop: shopSlice
})

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
